import { render, staticRenderFns } from "./rzrqTopFive.vue?vue&type=template&id=71bb6237&scoped=true&"
import script from "./rzrqTopFive.vue?vue&type=script&lang=js&"
export * from "./rzrqTopFive.vue?vue&type=script&lang=js&"
import style0 from "./rzrqTopFive.vue?vue&type=style&index=0&id=71bb6237&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb6237",
  null
  
)

export default component.exports